<div *ngIf="!displayInline; else displayInlineTpl">
  <div>{{ address.address1 }},</div>
  <div *ngIf="address.address2">{{ address.address2 }},</div>
  <div *ngIf="address.address3">{{ address.address3 }},</div>
  <div *ngIf="address.description">{{ address.description }},</div>
  <div *ngIf="address.neighborhood">{{ address.neighborhood }},</div>
  <div>
    {{ address.city ? address.city + "," : "" }} {{ address.state }}
    {{ address.postalCode }}
  </div>
  <div>{{ country }}</div>
</div>

<ng-template #displayInlineTpl>
  {{ inlineAddress }}
</ng-template>
